module.exports = __webpack_public_path__ + "img/brand-bootstrap.3ff965b6.svg";